import EnumItem from '../../../common/utils/Enum'
import { i18n } from '../../../common/utils/i18n'

export default new EnumItem({
  NORMAL: { value: 1, text: i18n.gettext('普通商家') },
  CKA: { value: 2, text: i18n.gettext('CKA') },
  KA: { value: 3, text: i18n.gettext('KA') }
})
